<div class="container">
  <mat-toolbar class="custom-header">
  <span (click)="guiService.goTo('auth/login')">
    <mat-icon svgIcon="mat:arrow_back"></mat-icon>
  </span>
</mat-toolbar>
  <h1>Quiz</h1>
  <div *ngIf="currentStep < steps.length" style="text-align: center;">
    <p>{{ steps[currentStep].question | translate }}</p>

    <button class="its-button mt-4" *ngFor="let optKey of getFilteredOptions()" (click)="selectedOptKey = optKey"
      [class.its-button-not-selected]="selectedOptKey !== optKey">
      {{ ('LOGIN.QUIZ.' + optKey) | translate }}
    </button>
  </div>

  <div *ngIf="currentStep >= steps.length">
    <h2 *ngIf="suggestedPrograms?.length < 2">{{ 'LOGIN.QUIZ.result_title' | translate }}</h2>
    <h2 *ngIf="suggestedPrograms?.length > 1">{{ 'LOGIN.QUIZ.results_title' | translate }}</h2>
    <span *ngIf="suggestedPrograms?.length > 0">
      <div class="program" *ngFor="let suggestedProgram of suggestedPrograms; let i = index" [class.selected-program]="selectedProgramIndex === i">
        <div class="program-card" (click)="selectedProgramIndex === i ? selectedProgramIndex = null : selectedProgramIndex = i">
          <img [src]="environment+'/'+suggestedProgram.id+'/images/main'" alt="">
        </div>
        <div *ngIf="selectedProgramIndex === i" class="infos">
          <div class="info-box">
            <p class="data-label">{{"PROGRAM-DETAIL.WEEK-NUMBER" | translate}}</p>
            <p class="data">{{suggestedProgram.numberOfWeeks}}</p>
          </div>
          <div class="info-box">
            <p class="data-label">{{"PROGRAM-DETAIL.WEEKLY-WORKOUTS" | translate}}</p>
            <p class="data">{{suggestedProgram.weeklyWorkouts}}</p>
          </div>
          <div class="info-box">
            <p class="data-label">{{"PROGRAM-DETAIL.WORKOUT-DURATION" | translate}}</p>
            <p class="data">{{suggestedProgram.workoutDurationInMinutes}}</p>
          </div>
          <p class="description">
            {{suggestedProgram.i18nDescription[translate.currentLang.toUpperCase()]}}
          </p>
          <button class="its-button" (click)="selectProgram(suggestedProgram.id)">
            <span *ngIf="!spinner">{{"PROGRAM-DETAIL.SELECT" | translate}}</span>
            <mat-spinner *ngIf="spinner" diameter="14"></mat-spinner>
          </button>
        </div>
      </div>
    </span>
  </div>
  <div class="footer-position">
    <p class="text-center" *ngIf="currentStep > 0" (click)="goBack()">
      {{"PROFILE.NUTRITION.SURVEY.BACK" | translate}}</p>
    <button class="its-button" (click)="selectOption(selectedOptKey)" *ngIf="currentStep < steps.length"
      [disabled]="!selectedOptKey">{{"PROFILE.NUTRITION.SURVEY.NEXT" | translate}}</button>
  </div>
</div>
